
export default function SocialProof() {
  const stats = [
    { value: '2.5M+', label: 'Total Content Views' },
    { value: '50+', label: 'Brand Partners' },
    { value: '3x', label: 'Average ROAS' },
    { value: '48h', label: 'Turnaround Time' }
  ];

  const testimonials = [
    {
      quote: "Sarah's content consistently outperforms our in-house creatives. Her UGC videos drove a 3.2x ROAS on our Meta campaigns.",
      name: 'Jessica M.',
      role: 'Marketing Director',
      brand: 'GlowBeauty',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20woman%20headshot%20portrait%20smiling%20confident%20business%20attire%20neutral%20background%20corporate%20style&width=80&height=80&seq=test1&orientation=squarish'
    },
    {
      quote: "Working with Sarah was seamless. She understood our brand voice immediately and delivered content that truly resonated with our audience.",
      name: 'Michael T.',
      role: 'Brand Manager',
      brand: 'TechNova',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20man%20headshot%20portrait%20friendly%20smile%20business%20casual%20neutral%20background%20corporate%20style&width=80&height=80&seq=test2&orientation=squarish'
    },
    {
      quote: "The authenticity in Sarah's videos is unmatched. Our engagement rates increased by 40% after using her content in our ads.",
      name: 'Amanda L.',
      role: 'Social Media Lead',
      brand: 'UrbanStyle',
      avatar: 'https://readdy.ai/api/search-image?query=young%20professional%20woman%20headshot%20portrait%20warm%20smile%20creative%20industry%20style%20neutral%20background&width=80&height=80&seq=test3&orientation=squarish'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 mb-12 md:mb-20">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-4 md:p-6 bg-stone-50 rounded-xl md:rounded-2xl">
              <div className="text-2xl md:text-4xl font-bold text-stone-900 mb-1 md:mb-2">{stat.value}</div>
              <div className="text-xs md:text-sm text-stone-500">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="text-center mb-8 md:mb-12">
          <div className="text-xs uppercase tracking-widest text-amber-700 mb-3 md:mb-4">Testimonials</div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900">
            What Brands <span className="font-light italic">Say</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-stone-50 rounded-2xl md:rounded-3xl p-6 md:p-8 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center gap-1 mb-4 md:mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-sm md:text-base"></i>
                ))}
              </div>
              
              <p className="text-sm md:text-base text-stone-700 mb-6 md:mb-8 leading-relaxed">
                "{testimonial.quote}"
              </p>
              
              <div className="flex items-center gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-bold text-stone-900 text-sm md:text-base">{testimonial.name}</div>
                  <div className="text-xs md:text-sm text-stone-500">{testimonial.role}, {testimonial.brand}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
